import type { ReactNode } from "react";
import { motion } from "motion/react";
import type { LucideIcon } from "lucide-react";
import { GlassCard, useAccent } from "@/ui";

interface TopicCardProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
}

/** Shared content card for this chapter: accent icon chip, display title, free-form body. */
export function TopicCard({ icon: Icon, title, children }: TopicCardProps) {
  const [from, to] = useAccent();
  return (
    <motion.div whileHover={{ y: -6 }} className="h-full">
      <GlassCard glow className="flex h-full flex-col gap-6 p-9">
        <span
          className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl"
          style={{ background: `linear-gradient(135deg, ${from}2e, ${to}2e)` }}
        >
          <Icon className="h-8 w-8 text-white/90" strokeWidth={1.75} />
        </span>
        <h3 className="font-display text-3xl font-semibold leading-tight text-white">{title}</h3>
        <div className="flex flex-1 flex-col gap-5">{children}</div>
      </GlassCard>
    </motion.div>
  );
}
